"use client"
import { usePermissionStore } from "@/core/stores/permission.store"
import { DeleteOutlined } from "@ant-design/icons"
import { Popconfirm, Button } from "antd"

interface DeleteButtonProps {
    onConfirm: () => any,
    length: number,
    loading: boolean,
    noGap?: boolean
}
export const DeleteButton: React.FC<DeleteButtonProps> = ({onConfirm, length, loading, noGap}) => {
    const permissionStore = usePermissionStore();
    if (!permissionStore.page.delete) return null;
    return <Popconfirm
        title={`Xoá ${length} bản ghi?`}
        description={`Bạn có chắc chắn muốn xoá ${length} bản ghi đã chọn?`}
        onConfirm={onConfirm}
        okText="Xoá"
        cancelText="Huỷ"
    >
        <Button className={noGap?undefined:'ml-4'}loading={loading} type="primary" danger icon={<DeleteOutlined />} disabled={length === 0}>Xoá</Button>
    </Popconfirm>
}